import React, { useEffect, useState } from 'react';
import './MatrimonyProfile.css';
import logo from './nobglogo.png'; 
import vicsitLogo from './vicsitlogo.png'; 
import background from './background2.jpg'; 
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-quill/dist/quill.snow.css';


const MatrimonyProfile = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [profile, setProfile] = useState(null);
  const [expired, setExpired] = useState(false);
  const [error, setError] = useState(""); // new error state
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [currentPhoto, setCurrentPhoto] = useState(0);
  
  // Extract token from URL query string
  const token = new URLSearchParams(window.location.search).get('token');

  const handleScroll = () => {
    const offset = window.scrollY;
    setScrolled(offset > 300);
  };

  // Smooth scroll to a section by id and close menu if open
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    if (!token) {
      setError("Token not provided. Please contact the administrator.");
      return;
    }

    fetch(`https://kanhamatrimonials.com/get_profile.php?token=${token}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.expired) {
          setError("This link has expired. Please contact the administrator for a new link.");
          setExpired(true);
        } else if (data.error) {
          setError(data.error + " Please contact the administrator.");
        } else {
          setProfile(data);
        }
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        setError("An unexpected error occurred. Please try again later.");
      });

    // Prevent copy, screenshot, etc.
    document.addEventListener('contextmenu', (e) => e.preventDefault());
    document.addEventListener('copy', (e) => e.preventDefault());
    document.addEventListener('dragstart', (e) => e.preventDefault());
    document.addEventListener('keyup', (e) => {
      if (e.key === 'PrintScreen') {
        alert('Screenshots are not allowed!');
        document.body.classList.add('screenshot-blocked');
      }
    });
    window.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        document.body.classList.add('screenshot-blocked');
      } else {
        document.body.classList.remove('screenshot-blocked');
      }
    });

    return () => window.removeEventListener('scroll', handleScroll);
  }, [token]);

  // If there is an error, render a dedicated error page.
  if (error) {
    return (
      <div className="error-page">
        <div className="error-header">
          <img src={logo} alt="Logo" className="error-logo" />
          <h1>Page Unavailable</h1>
        </div>
        <p className="error-message">{error}</p>
        <p>Please contact admin at <a href="mailto:support@kanhamatrimonials.com">support@kanhamatrimonials.com</a></p>
      </div>
    );
  }

  // Parse the photos array (if available)
  const photos = profile && profile.photos ? JSON.parse(profile.photos) : [];

  return (
    <div className="profile-container">
      <div className={`hamburger-menu ${menuOpen ? 'open' : ''}`}
           onClick={() => setMenuOpen(!menuOpen)}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>

      {/* Mobile Header – Visible only on small screens */}
      <header className="mobile-header">
        <div className="mobile-header-content">
          {/* Mobile header content */}
        </div>
      </header>

      <div className={`sidebar ${menuOpen ? 'open' : ''}`}>
  <div className="logo-container">
    <img src={logo} alt="Logo" className="logo-image" />
  </div>
  <div className="separator-line"></div>
  <div className="menu-item" onClick={() => scrollToSection('home')}>
    <i className="fas fa-home"></i> Home
  </div>
  <div className="menu-item" onClick={() => scrollToSection('whoAmI')}>
    <i className="fas fa-user"></i> Who Am I
  </div>
  <div className="menu-item" onClick={() => scrollToSection('myBasics')}>
    <i className="fas fa-info-circle"></i> My Basics
  </div>
  <div className="menu-item" onClick={() => scrollToSection('aboutMyFamily')}>
    <i className="fas fa-users"></i> About My Family
  </div>
  <div className="menu-item" onClick={() => scrollToSection('myEducation')}>
    <i className="fas fa-graduation-cap"></i> My Education
  </div>
  <div className="menu-item" onClick={() => scrollToSection('residentialInformation')}>
    <i className="fas fa-building"></i> Residential Information
  </div>
  <div className="menu-item" onClick={() => scrollToSection('businessDetails')}>
    <i className="fas fa-briefcase"></i> Business Details
  </div>
  <div className="menu-item" onClick={() => scrollToSection('photo-gallery-section')}>
    <i className="fas fa-camera"></i> Photos
  </div>
  <div className="separator-line"></div>
  <div className="footer-section">
    <div className="social-icons">
      <a href="#"><i className="fab fa-facebook-f"></i></a>
      <a href="#"><i className="fab fa-instagram"></i></a>
      <a href="#"><i className="fab fa-linkedin"></i></a>
    </div>
    <p className="copyright">© 2025 Kanha Matrimonials. All Rights Reserved.</p>
  </div>
</div>


      <div className="main-content">
        <div id="home" className="hero-section" style={{ backgroundImage: `url(${background})` }}>
          <h1>I'm {profile ? profile.name : "Loading..."}</h1>
          <p className="sub-title">{profile ? profile.subtitle : ""}</p>
        </div>
        <div id="whoAmI" className={`about-section ${scrolled ? 'visible' : ''}`}>
          <h2>Who Am I</h2>
          <div className="separatorlineheader"></div>
          <div dangerouslySetInnerHTML={{ __html: profile ? profile.who_am_i : "" }} />
          <div className="watermark"></div>
        </div>
        <div id="myBasics" className={`primary-section ${scrolled ? 'visible' : ''}`}>
          <h2>My Basics</h2>
          <div className="separatorlineheader"></div>
          <div dangerouslySetInnerHTML={{ __html: profile ? profile.my_basics : "" }} />
          <div className="watermark"></div>
        </div>
        <div id="aboutMyFamily" className={`primary-section ${scrolled ? 'visible' : ''}`}>
          <h2>About My Family</h2>
          <div className="separatorlineheader"></div>
          <div dangerouslySetInnerHTML={{ __html: profile ? profile.about_my_family : "" }} />
          <div className="watermark"></div>
        </div>
        <div id="myEducation" className={`primary-section ${scrolled ? 'visible' : ''}`}>
          <h2>My Education</h2>
          <div className="separatorlineheader"></div>
          <div dangerouslySetInnerHTML={{ __html: profile ? profile.my_education : "" }} />
          <div className="watermark"></div>
        </div>
        <div id="residentialInformation" className={`primary-section ${scrolled ? 'visible' : ''}`}>
          <h2>Residential Information</h2>
          <div className="separatorlineheader"></div>
          <div dangerouslySetInnerHTML={{ __html: profile ? profile.residential_information : "" }} />
          <div className="watermark"></div>
        </div>
        <div id="businessDetails" className={`primary-section ${scrolled ? 'visible' : ''}`}>
          <h2>Business Details</h2>
          <div className="separatorlineheader"></div>
          <div dangerouslySetInnerHTML={{ __html: profile ? profile.business_details : "" }} />
          <div className="watermark"></div>
        </div>
        <div id="photo-gallery-section" className="photo-gallery-section">
          <h2>Photos</h2>
          {photos.length > 0 ? (
            <div className="main-photo" onClick={() => { setGalleryOpen(true); setCurrentPhoto(0); }}>
              <img src={photos[0]} alt="Profile Main" />
            </div>
          ) : (
            <p>No photos available.</p>
          )}
          <div className="watermark"></div>
        </div>
        <footer className="small-footer">
        <p>
            © 2025 Kanha Matrimonials. All Rights Reserved. &nbsp;|&nbsp; 
            Developed by <a href="https://vicsit.in" target="_blank" rel="noopener noreferrer">VICSIT</a> &nbsp;|&nbsp; 
            For inquiries, contact <a href="mailto:support@kanhamatrimonials.com">support@kanhamatrimonials.com</a>
        </p>
        </footer>



      </div>

      {galleryOpen && (
        <div className="gallery-modal" onClick={() => setGalleryOpen(false)}>
          <div className="gallery-content" onClick={(e) => e.stopPropagation()}>
            <button 
              className="nav-arrow left-arrow" 
              onClick={() => setCurrentPhoto((prev) => prev > 0 ? prev - 1 : photos.length - 1)}
            >
              &#8592;
            </button>
            <img src={photos[currentPhoto]} alt={`Gallery ${currentPhoto}`} className="gallery-photo" />
            <button 
              className="nav-arrow right-arrow" 
              onClick={() => setCurrentPhoto((prev) => prev < photos.length - 1 ? prev + 1 : 0)}
            >
              &#8594;
            </button>
            <button className="close-gallery-btn" onClick={() => setGalleryOpen(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MatrimonyProfile;
